module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/07foreword#for"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/07foreword#for"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Foreword")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1"
    }
  }, [_vm._v("INTRODUCTION TO BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev1"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev1"
    }
  }, [_vm._v("Quick Start Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev2"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev2"
    }
  }, [_vm._v("About This Book")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev3"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev3"
    }
  }, [_vm._v("What’s In Here?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev4"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev4"
    }
  }, [_vm._v("Brewing with Both Halves of Your Brain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev5"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev5"
    }
  }, [_vm._v("Thinking Like a Scientist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev6"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev6"
    }
  }, [_vm._v("What to Worry About")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev7"
    }
  }, [_vm._v("23")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev7"
    }
  }, [_vm._v("Chemical and Biochemical Concepts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev8"
    }
  }, [_vm._v("26")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev8"
    }
  }, [_vm._v("Brewing Like an Artist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev9"
    }
  }, [_vm._v("27")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/08chapter01#ch1lev9"
    }
  }, [_vm._v("Getting Started and Getting Better")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2"
    }
  }, [_vm._v("UNDERSTANDING BEER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev1"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev1"
    }
  }, [_vm._v("Anatomy of a Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev2"
    }
  }, [_vm._v("32")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev2"
    }
  }, [_vm._v("Measurables")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev3"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev3"
    }
  }, [_vm._v("Intangibles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev4"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev4"
    }
  }, [_vm._v("Tasting and Evaluating Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev5"
    }
  }, [_vm._v("35")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev5"
    }
  }, [_vm._v("Our Senses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev6"
    }
  }, [_vm._v("38")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev6"
    }
  }, [_vm._v("The Tasting Act")])]), _vm._v(" "), _c('p', {
    staticClass: "toc4"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('em', [_c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev7"
    }
  }, [_vm._v("40")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev7"
    }
  }, [_vm._v("An Atlas of Beer Flavor and Character")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev8"
    }
  }, [_vm._v("42")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/09chapter02#ch2lev8"
    }
  }, [_vm._v("Judging, Competitions, and Certifications")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3"
    }
  }, [_vm._v("BREWING INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev1"
    }
  }, [_vm._v("46")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev1"
    }
  }, [_vm._v("Barley, Malt, and Grains")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev2"
    }
  }, [_vm._v("47")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev2"
    }
  }, [_vm._v("Malting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev3"
    }
  }, [_vm._v("51")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev3"
    }
  }, [_vm._v("Kilning and Roasting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev4"
    }
  }, [_vm._v("55")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev4"
    }
  }, [_vm._v("Malt Types")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev5"
    }
  }, [_vm._v("66")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev5"
    }
  }, [_vm._v("Understanding a Malt Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev6"
    }
  }, [_vm._v("67")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev6"
    }
  }, [_vm._v("Unmalted Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev7"
    }
  }, [_vm._v("70")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev7"
    }
  }, [_vm._v("Malt Extract")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev8"
    }
  }, [_vm._v("71")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev8"
    }
  }, [_vm._v("Roasting and Smoking Your Own Specialty Malts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev9"
    }
  }, [_vm._v("74")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev9"
    }
  }, [_vm._v("Brewing Sugars")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev10"
    }
  }, [_vm._v("76")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev10"
    }
  }, [_vm._v("Making Your Own Caramel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev11"
    }
  }, [_vm._v("76")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev11"
    }
  }, [_vm._v("Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev12"
    }
  }, [_vm._v("78")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev12"
    }
  }, [_vm._v("Hops: The Spice of Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev13"
    }
  }, [_vm._v("79")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev13"
    }
  }, [_vm._v("Hops’ Form and Function")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev14"
    }
  }, [_vm._v("79")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev14"
    }
  }, [_vm._v("Hops in the Brew")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev15"
    }
  }, [_vm._v("80")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev15"
    }
  }, [_vm._v("Hop Varieties and Personality Groups")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev16"
    }
  }, [_vm._v("86")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev16"
    }
  }, [_vm._v("Hop Varieties in Detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev17"
    }
  }, [_vm._v("96")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev17"
    }
  }, [_vm._v("Water without Tears")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev18"
    }
  }, [_vm._v("98")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev18"
    }
  }, [_vm._v("Brewing Water Minerals in Detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font12"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev19"
    }
  }, [_vm._v("99")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev19"
    }
  }, [_vm._v("Water Minerals and Brewing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev20"
    }
  }, [_vm._v("104")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev20"
    }
  }, [_vm._v("Water Trace Minerals in Detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev21"
    }
  }, [_vm._v("105")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev21"
    }
  }, [_vm._v("Alternate Ingredients")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev22"
    }
  }, [_vm._v("106")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev22"
    }
  }, [_vm._v("Herbs and Spices")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev23"
    }
  }, [_vm._v("110")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev23"
    }
  }, [_vm._v("Fruits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev24"
    }
  }, [_vm._v("112")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/10chapter03#ch3lev24"
    }
  }, [_vm._v("Vegetables and Beyond in Your Beer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4"
    }
  }, [_vm._v("THE BREWING PROCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev1"
    }
  }, [_vm._v("116")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev1"
    }
  }, [_c('span', {
    staticClass: "brown"
  }, [_vm._v("THE AMAZING SHAPE-SHIFTING BEER RECIPE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev2"
    }
  }, [_vm._v("118")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev2"
    }
  }, [_c('strong', [_c('em', [_vm._v("Your First Beer: Getting Started with Extract Brewing")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev3"
    }
  }, [_vm._v("119")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev3"
    }
  }, [_c('strong', [_c('em', [_vm._v("Extract Plus Steeped-Grain Procedure")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev4"
    }
  }, [_vm._v("120")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev4"
    }
  }, [_vm._v("Grain Crushing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev5"
    }
  }, [_vm._v("121")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev5"
    }
  }, [_vm._v("Mashing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev6"
    }
  }, [_vm._v("122")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev6"
    }
  }, [_vm._v("The Mash: Magic Porridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev7"
    }
  }, [_vm._v("126")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev7"
    }
  }, [_vm._v("Enzymes in Detail")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev8"
    }
  }, [_vm._v("127")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev8"
    }
  }, [_vm._v("The Mini-Mash Method")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev9"
    }
  }, [_vm._v("130")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev9"
    }
  }, [_vm._v("Infusion Mashing for All-Grain Brewing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev10"
    }
  }, [_vm._v("134")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev10"
    }
  }, [_vm._v("Doing It the Hard Way")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev11"
    }
  }, [_vm._v("140")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev11"
    }
  }, [_vm._v("Lautering and Sparging")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev12"
    }
  }, [_vm._v("142")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev12"
    }
  }, [_vm._v("Additional Sparging Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev13"
    }
  }, [_vm._v("144")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev13"
    }
  }, [_vm._v("Sparging with Recirculating Mash Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev14"
    }
  }, [_vm._v("146")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev14"
    }
  }, [_vm._v("The Boil")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev15"
    }
  }, [_vm._v("146")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev15"
    }
  }, [_vm._v("What Happens in the Kettle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev16"
    }
  }, [_vm._v("147")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev16"
    }
  }, [_vm._v("Managing the Boil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev17"
    }
  }, [_vm._v("149")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev17"
    }
  }, [_vm._v("Cooling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev18"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev18"
    }
  }, [_vm._v("Cleaning Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev19"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev19"
    }
  }, [_vm._v("Cleaning and Sanitizing Chemicals for the Home Brewery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev20"
    }
  }, [_vm._v("154")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/11chapter04#ch4lev20"
    }
  }, [_vm._v("Cleaning Your Equipment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5"
    }
  }, [_vm._v("156")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5"
    }
  }, [_vm._v("THE BREWERY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev1"
    }
  }, [_vm._v("158")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev1"
    }
  }, [_vm._v("Safety in the Brewery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev2"
    }
  }, [_vm._v("160")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev2"
    }
  }, [_vm._v("Your System, Your Goals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev3"
    }
  }, [_vm._v("161")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev3"
    }
  }, [_vm._v("Design Considerations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev4"
    }
  }, [_vm._v("163")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev4"
    }
  }, [_vm._v("Gear")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev5"
    }
  }, [_vm._v("163")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev5"
    }
  }, [_vm._v("Grain Mills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev6"
    }
  }, [_vm._v("165")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev6"
    }
  }, [_vm._v("Scales/Balances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev7"
    }
  }, [_vm._v("165")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev7"
    }
  }, [_vm._v("Burners, Flames, and Heaters")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev8"
    }
  }, [_vm._v("167")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev8"
    }
  }, [_vm._v("Mash/Lauter Tuns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev9"
    }
  }, [_vm._v("169")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev9"
    }
  }, [_vm._v("HERMS, RIMS, and Direct-Heated Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev10"
    }
  }, [_vm._v("170")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev10"
    }
  }, [_vm._v("Grant (Wort Reciever)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev11"
    }
  }, [_vm._v("171")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev11"
    }
  }, [_vm._v("Moving Wort")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev12"
    }
  }, [_vm._v("171")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev12"
    }
  }, [_vm._v("Hoses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev13"
    }
  }, [_vm._v("172")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev13"
    }
  }, [_vm._v("Pipe and Tubing Fittings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev14"
    }
  }, [_vm._v("173")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev14"
    }
  }, [_vm._v("Pumps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev15"
    }
  }, [_vm._v("175")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev15"
    }
  }, [_vm._v("Brew Kettles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev16"
    }
  }, [_vm._v("177")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev16"
    }
  }, [_vm._v("Hop Back")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev17"
    }
  }, [_vm._v("178")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev17"
    }
  }, [_vm._v("Wort Chiller")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev18"
    }
  }, [_vm._v("180")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev18"
    }
  }, [_vm._v("Wort Aeration")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev19"
    }
  }, [_vm._v("182")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev19"
    }
  }, [_vm._v("Fermenters")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev20"
    }
  }, [_vm._v("184")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev20"
    }
  }, [_vm._v("Measurements and Instrumentation")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev21"
    }
  }, [_vm._v("187")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev21"
    }
  }, [_vm._v("Packaging Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev22"
    }
  }, [_vm._v("187")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev22"
    }
  }, [_vm._v("Bottling Gear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev23"
    }
  }, [_vm._v("189")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev23"
    }
  }, [_vm._v("Keg and Draft Systems")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev24"
    }
  }, [_vm._v("193")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/12chapter05#ch5lev24"
    }
  }, [_vm._v("Firkins, Pumps, and Real Ale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6"
    }
  }, [_vm._v("194")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6"
    }
  }, [_vm._v("YEAST "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" FERMENTATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev1"
    }
  }, [_vm._v("196")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev1"
    }
  }, [_vm._v("Yeast in Brewing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev2"
    }
  }, [_vm._v("198")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev2"
    }
  }, [_vm._v("Yeast Biology")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev3"
    }
  }, [_vm._v("200")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev3"
    }
  }, [_vm._v("Yeast and the Biochemistry of Beer Flavor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev4"
    }
  }, [_vm._v("202")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev4"
    }
  }, [_vm._v("Yeast Flavor Chemicals in Beer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev5"
    }
  }, [_vm._v("204")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev5"
    }
  }, [_vm._v("Yeast Growth and Fermentation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev6"
    }
  }, [_vm._v("206")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev6"
    }
  }, [_vm._v("Yeast Types")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev7"
    }
  }, [_vm._v("210")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev7"
    }
  }, [_vm._v("Wild Yeast: Aliens in Your Brewery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev8"
    }
  }, [_vm._v("212")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev8"
    }
  }, [_vm._v("The Care and Feeding of Yeast")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev9"
    }
  }, [_vm._v("214")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev9"
    }
  }, [_vm._v("Pitching Rates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev10"
    }
  }, [_vm._v("215")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev10"
    }
  }, [_vm._v("Wort Aeration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev11"
    }
  }, [_vm._v("217")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev11"
    }
  }, [_vm._v("Yeast Unleashed: Practical Fermenting")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev12"
    }
  }, [_vm._v("219")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev12"
    }
  }, [_vm._v("Conditioning and Maturation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev13"
    }
  }, [_vm._v("224")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev13"
    }
  }, [_vm._v("Packaging and Serving Your Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev14"
    }
  }, [_vm._v("224")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev14"
    }
  }, [_vm._v("Capping It Off: Bottling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev15"
    }
  }, [_vm._v("228")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev15"
    }
  }, [_vm._v("The Delights of Kegging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev16"
    }
  }, [_vm._v("232")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev16"
    }
  }, [_vm._v("Cellaring Your Beer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev17"
    }
  }, [_vm._v("233")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/13chapter06#ch6lev17"
    }
  }, [_vm._v("Wood- and Barrel-Aged Beers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_vm._v("236")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7"
    }
  }, [_vm._v("THE ART "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" SCIENCE "), _c('span', {
    staticClass: "font"
  }, [_vm._v("of the")]), _vm._v(" RECIPE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev1"
    }
  }, [_vm._v("238")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev1"
    }
  }, [_vm._v("Thinking Through Your Goals")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev2"
    }
  }, [_vm._v("239")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev2"
    }
  }, [_vm._v("Integrating Ingredients and Process")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev3"
    }
  }, [_vm._v("240")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev3"
    }
  }, [_vm._v("Record Keeping")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg240lev1"
    }
  }, [_vm._v("240")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#pg240lev1"
    }
  }, [_vm._v("Worksheet Instructions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev4"
    }
  }, [_vm._v("242")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev4"
    }
  }, [_vm._v("Art and the Brewer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev5"
    }
  }, [_vm._v("245")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev5"
    }
  }, [_vm._v("The Tools of the Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev6"
    }
  }, [_vm._v("248")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev6"
    }
  }, [_vm._v("Ideas and Inspirations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev7"
    }
  }, [_vm._v("249")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev7"
    }
  }, [_vm._v("Structuring a Beer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev8"
    }
  }, [_vm._v("253")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev8"
    }
  }, [_vm._v("The Numbers Game")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev9"
    }
  }, [_vm._v("254")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev9"
    }
  }, [_vm._v("Calculating the Grain Bill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev10"
    }
  }, [_vm._v("260")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev10"
    }
  }, [_vm._v("Hops in the Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev11"
    }
  }, [_vm._v("270")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev11"
    }
  }, [_vm._v("Other Flavorings")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev12"
    }
  }, [_vm._v("270")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev12"
    }
  }, [_vm._v("Spices and Seasonings in the Recipe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev13"
    }
  }, [_vm._v("271")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev13"
    }
  }, [_vm._v("Recipe Considerations for Fruit Beers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev14"
    }
  }, [_vm._v("272")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/14chapter07#ch7lev14"
    }
  }, [_vm._v("Yeast and Fermentation Choices")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8"
    }
  }, [_vm._v("274")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8"
    }
  }, [_vm._v("RECIPES: STYLES "), _c('span', {
    staticClass: "font"
  }, [_vm._v("and")]), _vm._v(" BEYOND")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev1"
    }
  }, [_vm._v("276")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev1"
    }
  }, [_vm._v("Calculations and Assumptions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev2"
    }
  }, [_vm._v("277")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev2"
    }
  }, [_vm._v("Brewing Methods in the Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev3"
    }
  }, [_vm._v("278")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev3"
    }
  }, [_vm._v("About Styles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev4"
    }
  }, [_vm._v("280")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev4"
    }
  }, [_vm._v("A Timeline of Beer History and Technology")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev5"
    }
  }, [_vm._v("282")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev5"
    }
  }, [_vm._v("A Brewer’s Overview of Beer Styles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev6"
    }
  }, [_vm._v("282")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev6"
    }
  }, [_vm._v("English Ale, Stout, and Porter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev7"
    }
  }, [_vm._v("295")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev7"
    }
  }, [_vm._v("German Ales, Hybrid Ales, and Weissbier")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev8"
    }
  }, [_vm._v("300")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev8"
    }
  }, [_vm._v("Lager")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev9"
    }
  }, [_vm._v("306")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev9"
    }
  }, [_vm._v("Belgium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev10"
    }
  }, [_vm._v("313")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev10"
    }
  }, [_vm._v("New American Classics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev11"
    }
  }, [_vm._v("321")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev11"
    }
  }, [_vm._v("Planet Homebrew")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev12"
    }
  }, [_vm._v("322")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev12"
    }
  }, [_vm._v("Italy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev13"
    }
  }, [_vm._v("325")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev13"
    }
  }, [_vm._v("Scandinavia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev14"
    }
  }, [_vm._v("327")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev14"
    }
  }, [_vm._v("Brazil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev15"
    }
  }, [_vm._v("330")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev15"
    }
  }, [_vm._v("Argentina")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev16"
    }
  }, [_vm._v("332")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev16"
    }
  }, [_vm._v("Nuevo Latino Cerveza en Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev11"
    }
  }, [_vm._v("334")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev17"
    }
  }, [_vm._v("Australia and New Zealand")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev18"
    }
  }, [_vm._v("336")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev18"
    }
  }, [_vm._v("Ingredient-Driven Beers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev19"
    }
  }, [_vm._v("336")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev19"
    }
  }, [_vm._v("Herb and Spice Beers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev21"
    }
  }, [_vm._v("344")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev21"
    }
  }, [_vm._v("Vegetable-Flavored Beers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev22"
    }
  }, [_vm._v("346")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev22"
    }
  }, [_vm._v("Screw Styles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev23"
    }
  }, [_vm._v("346")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev23"
    }
  }, [_vm._v("Brewing with the Seasons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev24"
    }
  }, [_vm._v("352")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/15chapter08#ch8lev24"
    }
  }, [_vm._v("Brewing the Perfect Party Beer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9"
    }
  }, [_vm._v("354")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Chapter 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9"
    }
  }, [_vm._v("TROUBLESHOOTING")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev1"
    }
  }, [_vm._v("356")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev1"
    }
  }, [_vm._v("Ingredients, Recipes, and Brewing")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev2"
    }
  }, [_vm._v("357")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev2"
    }
  }, [_vm._v("Yeast and Fermentation Behavior")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev3"
    }
  }, [_vm._v("358")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev3"
    }
  }, [_vm._v("Sensory Problems")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev4"
    }
  }, [_vm._v("361")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/16chapter09#ch9lev4"
    }
  }, [_vm._v("Packaging and Serving Problems")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#res"
    }
  }, [_vm._v("362")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#res"
    }
  }, [_c('span', {
    staticClass: "orange"
  }, [_vm._v("Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2t"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#scale"
    }
  }, [_vm._v("363")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#scale"
    }
  }, [_vm._v("Conversion Scales for Common Units of Brewing Measurement")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "font7"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#weight"
    }
  }, [_vm._v("364")])])]), _vm._v(" "), _c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#weight"
    }
  }, [_vm._v("Weights and Measures Conversions (U.S./U.K.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#gloss"
    }
  }, [_vm._v("365")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#gloss"
    }
  }, [_vm._v("Glossary of Beer and Brewing Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#fur"
    }
  }, [_vm._v("371")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#fur"
    }
  }, [_vm._v("Further Reading")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#furlev1"
    }
  }, [_vm._v("371")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#furlev1"
    }
  }, [_vm._v("Modern Books on Beer Styles and Brewing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#furlev2"
    }
  }, [_vm._v("372")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#furlev2"
    }
  }, [_vm._v("Historical Brewing Texts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#org"
    }
  }, [_vm._v("373")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#org"
    }
  }, [_vm._v("Organizations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#school"
    }
  }, [_vm._v("373")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#school"
    }
  }, [_vm._v("Schools")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17resources#herb"
    }
  }, [_vm._v("373")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/17resources#herb"
    }
  }, [_vm._v("Herb and Spice Resources")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/18index#ind"
    }
  }, [_vm._v("374")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/18index#ind"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/19author"
    }
  }, [_vm._v("385")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/xhtml/19author"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36032de0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-contents.vue
// module id = 72
// module chunks = 0